// import node module libraries
import { Link } from 'react-router-dom';
import { Card, Table, ProgressBar, Image } from 'react-bootstrap';

// import translation
import { useTranslation } from 'react-i18next';

const RecentFlowsOutputs = ({item, onReload}) => {
	const { t } = useTranslation();

	return (
		<Card>
			<Card.Header className="card-header-height d-flex justify-content-between align-items-center">
				<div>
					{' '}
					<h4 className="mb-0">{t('Recent Flow Outputs')}</h4>
				</div>
				<div>
					<Link onClick={onReload} className="">
						<i className="fe fe-rotate-cw ms-2 text-muted"></i>
					</Link>
				</div>
			</Card.Header>

			{/* table */}
			<div className="overflow-y-hidden">
				{item.length === 0 ? (
					<div className="text-center p-3">{t('No Flow Outputs found')}</div>
				) : (
					<Table hover responsive className="mb-0 text-nowrap table-centered">
						<thead className="table-light">
							<tr>
								<th scope="col">{t('Flow')}</th>
								<th scope="col">{t('Date')}</th>
								<th scope="col">{t('Status')}</th>
							</tr>
						</thead>
						<tbody>
							{item.map((flow, index) => {
								return (
									<tr key={index}>
										<td>{flow.flow_key}</td>
										<td>{flow.flow_timestamp_created}</td>
										<td>{flow.flow_status}</td>
									</tr>
								);
							})}
						</tbody>
					</Table>
				)}
			</div>
		</Card>
	);
};
export default RecentFlowsOutputs;
